import { createSvgIcon } from '@mui/material/utils';

const Spark = createSvgIcon(
    <svg viewBox="0 0 960 960">
        <path d="M423.845,418.516h-112v-106.516h90.184c12.009,0,21.816-9.807,21.816-21.816v-90.184h106.516v112c0,59.042-47.834,106.516-106.516,106.516ZM311.805,429.484h-112v106.516h90.184c12.009,0,21.816,9.807,21.816,21.816v90.184h106.516v-112c0-59.042-47.834-106.516-106.516-106.516ZM670.021,424c-12.009,0-21.816-9.807-21.816-21.816v-90.184h-106.516v112c0,59.042,47.834,106.516,106.516,106.516h112v-106.516h-90.184ZM429.289,648v112h106.516v-90.184c0-12.009,9.807-21.816,21.816-21.816h90.184v-106.516h-112c-59.042,0-106.516,47.834-106.516,106.516Z" />
    </svg>,
    'Spark'
);

export { Spark };
